export default "__VITE_ASSET__Cs1Qb_In__"